import React from 'react';
import { RectangleSkeleton } from '@sm360/widget-commons-general';

const PriceSkeleton = ({ sellingPriceLabel }) => (
    <div className="listing-tile-all-price">
        <div className="listing-tile-all-price-title sr-text">
            <div className="is-bold">{sellingPriceLabel}</div>
        </div>

        <div className="listing-tile-all-price-info">
            <div className="price is-bold is-price">
                <RectangleSkeleton width={101} height={30} />
                <div className="disclaimer-price is-light">
                    <RectangleSkeleton width={176} height={15} />
                </div>
            </div>
        </div>
    </div>
);

PriceSkeleton.displayName = 'PriceSkeleton';
export default PriceSkeleton;
